import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { audiencesList, productionsList } from '@/api/resources';
import { warm } from '@/api/loaders';
import { requireCapability } from '@/lib/route-guards';
import { NewAudienceFlow } from '@/screens/new-audience';

export const Route = createFileRoute('/audiences/new')({
  beforeLoad: requireCapability('audiences_edit'),
  validateSearch: (search: Record<string, unknown>): { duplicate?: string } => ({
    duplicate: typeof search.duplicate === 'string' && search.duplicate
      ? search.duplicate
      : undefined,
  }),
  loader: ({ context }) => warm(context.queryClient, audiencesList({}), productionsList({})),
  component: Page,
});

function Page() {
  const navigate = useNavigate();
  const { duplicate } = Route.useSearch();
  return (
    <NewAudienceFlow
      onCreated={(id) => void navigate({ to: '/audiences', search: { created: id } })}
      duplicateId={duplicate}
    />
  );
}
